import { API_URLS } from "../../config/apiUrls";
import axiosInstance from "../../config/axios";

export const getTypeFour = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.conectvityVariantApi, {
      params: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const getTypeFourCategory = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.connectivityTypeApi, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const addTypeFourCategory = (reqBody) => {
  try {
    const response = axiosInstance.post(API_URLS.connectivityTypeApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const updateTypeFourCategory = (reqBody) => {
  try {
    const response = axiosInstance.put(API_URLS.connectivityTypeApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteTypeFourCategory = (reqBody) => {
  try {
    const response = axiosInstance.delete(API_URLS.connectivityTypeApi, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const addTypeFour = (reqBody) => {
  try {
    const response = axiosInstance.post(API_URLS.conectvityVariantApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteTypeFour = (reqBody) => {
  try {
    const response = axiosInstance.delete(API_URLS.conectvityVariantApi, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const updateTypeFour = (reqBody) => {
  try {
    const response = axiosInstance.put(API_URLS.conectvityVariantApi, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
